






















import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'FormFieldText'

  vue:
    props: ['value', 'errors']

    components: {
      FormField,
    }

    data: ->
      catex: @value || {}

    computed:
      optionsForExclusive: ->
        instructions: 'Let sponsors know if you already have an exclusive deal with a partner for certain categories which will not be available for purchase'

      optionsForProhibited: ->
        instructions: 'Let sponsors know of any categories that are not allowed'

export default VueOptions.vue settings
